export const doctorSpecialties = [
  {
    value: 'administrator',
    label: 'Администратор / организация здравоохранения',
  },
  { value: 'obstetrician', label: 'Акушер' },
  { value: 'allergologist', label: 'Аллерголог' },
  { value: 'algologist', label: 'Алголог' },
  { value: 'angiosurgeon', label: 'Ангиохирург' },
  { value: 'andrologist', label: 'Андролог' },
  {
    value: 'anesthesiology_reanimatology',
    label: 'Анестезиология-реаниматология',
  },
  { value: 'bacteriologist', label: 'Бактериолог' },
  { value: 'venereologist', label: 'Венеролог' },
  { value: 'virologist', label: 'Вирусолог' },
  {
    value: 'general_practitioner',
    label: 'Врач общей практики / семейный врач',
  },
  { value: 'lfk_doctor', label: 'Врач ЛФК' },
  { value: 'mse_doctor', label: 'Врач МСЭ' },
  { value: 'lab_genetics_doctor', label: 'Врач лабораторной генетики' },
  { value: 'emergency_doctor', label: 'Скорая медицинская помощь' },
  { value: 'gastroenterologist', label: 'Гастроэнтеролог' },
  { value: 'hematologist', label: 'Гематолог' },
  { value: 'geneticist', label: 'Генетик' },
  { value: 'geriatrician', label: 'Гериатр' },
  { value: 'gynecologist', label: 'Гинеколог' },
  { value: 'disinfectologist', label: 'Дезинфектолог' },
  { value: 'dermatologist', label: 'Дерматолог' },
  { value: 'pediatric_allergologist', label: 'Детский аллерголог' },
  { value: 'pediatric_andrologist', label: 'Детский андролог' },
  { value: 'pediatric_hematologist', label: 'Детский гематолог' },
  { value: 'pediatric_cardiologist', label: 'Детский кардиолог' },
  { value: 'pediatric_neurologist', label: 'Детский невролог' },
  { value: 'pediatric_oncologist', label: 'Детский онколог' },
  { value: 'pediatric_psychiatrist', label: 'Детский психиатр' },
  {
    value: 'pediatric_anesthesiology_reanimatology',
    label: 'Детская анестезиология-реаниматология',
  },
  { value: 'pediatric_rheumatologist', label: 'Детский ревматолог' },
  { value: 'pediatric_dentist', label: 'Детский стоматолог' },
  { value: 'pediatric_urologist', label: 'Детский уролог' },
  { value: 'pediatric_surgeon', label: 'Детский хирург' },
  { value: 'pediatric_endocrinologist', label: 'Детский эндокринолог' },
  { value: 'dietologist', label: 'Диетолог' },
  { value: 'immunologist', label: 'Иммунолог' },
  { value: 'infectionist', label: 'Инфекционист' },
  { value: 'cardiologist', label: 'Кардиолог' },
  { value: 'cardiorheumatologist', label: 'Кардиоревматолог' },
  { value: 'clinical_pharmacologist', label: 'Клинический фармаколог' },
  { value: 'coloproctologist', label: 'Колопроктолог' },
  { value: 'cosmetologist', label: 'Косметолог' },
  { value: 'lab_diagnostician', label: 'Лабораторный диагност' },
  { value: 'mammologist', label: 'Маммолог' },
  { value: 'manual_therapist', label: 'Мануальный терапевт' },
  { value: 'microbiologist', label: 'Микробиолог' },
  { value: 'narcologist', label: 'Нарколог' },
  { value: 'neurologist', label: 'Невролог' },
  { value: 'neurosurgeon', label: 'Нейрохирург' },
  { value: 'neonatologist', label: 'Неонатолог' },
  { value: 'nephrologist', label: 'Нефролог' },
  { value: 'oncohematologist', label: 'Онкогематолог' },
  { value: 'oncologist', label: 'Онколог' },
  { value: 'oncomammologist', label: 'Онкомаммолог' },
  { value: 'oncopulmonologist', label: 'Онкопульмонолог' },
  { value: 'oncourologist', label: 'Онкоуролог' },
  { value: 'oncosurgeon', label: 'Онкохирург' },
  { value: 'orthodontist', label: 'Ортодонт' },
  { value: 'orthopedist', label: 'Ортопед' },
  { value: 'otorhinolaryngologist', label: 'Оториноларинголог' },
  { value: 'ophthalmologist', label: 'Офтальмолог' },
  { value: 'parasitologist', label: 'Паразитолог' },
  { value: 'pathologist', label: 'Патологоанатом' },
  { value: 'pediatrician', label: 'Педиатр' },
  { value: 'plastic_surgeon', label: 'Пластический хирург' },
  { value: 'occupational_pathologist', label: 'Профпатолог' },
  { value: 'psychiatrist', label: 'Психиатр' },
  { value: 'psychotherapist', label: 'Психотерапевт' },
  { value: 'pulmonologist', label: 'Пульмонолог' },
  { value: 'radiologist', label: 'Радиолог' },
  { value: 'radiotherapist', label: 'Радиотерапевт' },
  { value: 'rehabilitologist', label: 'Реабилитолог' },
  { value: 'rheumatologist', label: 'Ревматолог' },
  { value: 'roentgenologist', label: 'Рентгенолог' },
  { value: 'sexologist', label: 'Сексолог' },
  { value: 'cardiovascular_surgeon', label: 'Сердечно-сосудистый хирург' },
  { value: 'vascular_surgeon', label: 'Сосудистый хирург' },
  { value: 'sports_doctor', label: 'Спортивный врач' },
  { value: 'dental_therapist', label: 'Стоматолог-терапевт / общей практики' },
  { value: 'dental_orthopedist', label: 'Стоматолог-ортопед' },
  { value: 'dental_orthodontist', label: 'Стоматолог-ортодонт' },
  { value: 'dental_surgeon', label: 'Стоматолог-хирург' },
  { value: 'forensic_expert', label: 'Судебно-медицинский эксперт' },
  { value: 'surdologist', label: 'Сурдолог' },
  { value: 'therapist', label: 'Терапевт' },
  { value: 'toxicologist', label: 'Токсиколог' },
  { value: 'thoracic_surgeon', label: 'Торакальный хирург' },
  { value: 'traumatologist', label: 'Травматолог' },
  { value: 'transfusiologist', label: 'Трансфузиолог' },
  { value: 'ultrasound_specialist', label: 'УЗИ-специалист' },
  { value: 'urologist', label: 'Уролог' },
  { value: 'physiotherapist', label: 'Физиотерапевт' },
  { value: 'phthisiologist', label: 'Фтизиатр' },
  { value: 'functional_diagnostician', label: 'Функциональный диагност' },
  { value: 'chemotherapist', label: 'Химиотерапевт' },
  { value: 'surgeon', label: 'Хирург' },
  { value: 'maxillofacial_surgeon', label: 'Челюстно-лицевой хирург' },
  { value: 'endocrinologist', label: 'Эндокринолог' },
  { value: 'endoscopist', label: 'Эндоскопист' },
  { value: 'epidemiologist', label: 'Эпидемиолог' },
  { value: 'other', label: 'Другая специальность' },
]
